import { api } from "../api";

export const GameKingApi = {
    getGameKingList: (size, date, member_se) =>
        api.get(`api/event/game-king/list?size=${size}&date=${date}&my_member_se=${member_se}`),
};